import styled from 'styled-components';
import { ReactComponent as RawShareSVG } from '../../../../assets/icons/icon_share.svg';

export const IconShare = styled(RawShareSVG)``;
